import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getCookie } from "../Store/Storage/Cookies";

export const DashboardPrivateRoute = () => {
  const location = useLocation();
  const { pathname } = location;

  const cookie =
    getCookie("MconnectEnergyLoginData") !== ""
      ? JSON.parse(getCookie("MconnectEnergyLoginData"))
      : null;

  if (getCookie("MconnectEnergyLoginData") === "") {
    return <Navigate to="/" />;
  } else if (cookie?.userType === 2) {
    if (
      pathname === "/user" ||
      pathname === "/user/viewuser" ||
      pathname.includes("/subscription")
    ) {
      return <Navigate to="*" />;
    } else {
      return <Outlet />;
    }
  } else {
    return <Outlet />;
  }

  // return getCookie("MconnectEnergyLoginData") === "" ? (
  //   <Navigate to="/" />
  // ) : (
  //   <Outlet />
  // );
};

export const AuthPrivateRoute = () => {
  return getCookie("MconnectEnergyLoginData") !== "" ? (
    <Navigate to="/dashboard" />
  ) : (
    <Outlet />
  );
};
